import { AdMobRewardItem } from '@capacitor-community/admob';
import type React from 'react';
import { createContext, useContext } from 'react';

export type OptiDigitalClassName = `Billboard_${number}` | `Leaderboard_${number}` | `HalfpageAd_${number}` | `Content_${number}` | `Content_Bottom` | `Mobile_Pos${number}` | 'Mobile_Bottom';

export type AdUnitPage = 'home' | 'annonce' | 'recherche';

export enum BannerSlot {
  DONNONS_DETAIL_TOP = 'DONNONS_DETAIL_TOP',
  DONNONS_LIST_ITEM = 'DONNONS_LIST_ITEM',
  DONNONS_PROFIL_MIDDLE = 'DONNONS_PROFIL_MIDDLE',
  DONNONS_HOME_SIDE = 'DONNONS_HOME_SIDE',
  DONNONS_LIST_SIDE = 'DONNONS_LIST_SIDE',
  DONNONS_DETAIL_SIDE = 'DONNONS_DETAIL_SIDE',
  DONNONS_PROFIL_SIDE = 'DONNONS_PROFIL_SIDE',
  DONNONS_NATIVE = 'DONNONS_NATIVE',
}

export enum InterstitialSlot {
  INTERSTITIEL_OUVERTURE = 'INTERSTITIEL_OUVERTURE',
}

export type AdSize = '728x90' | '728x480' | '300x600' | '160x600' | '336x280' | '336x600' | '300x250' | '320x100';
export type Media = 'sm' | 'md' | 'lg';

export interface AdProps {
  size: AdSize;
  slot: BannerSlot;
  isMobile?: boolean;
  format?: string;
  clone?: number;
  media?: Media;
  isStartAuction?: boolean;
}

export type InterstitialStrategy = 'first-version';

export interface InterstitialProps {
  slot: InterstitialSlot;
  strategy: InterstitialStrategy;
}

export interface AdsContextType {
  Ad: React.FC<AdProps>;
  isLoaded: boolean;
  Interstitial: React.FC<InterstitialProps>;
  showReward: () => Promise<AdMobRewardItem | null> | void;
  showRewardText?: boolean;
}

export const AdsContext = createContext<AdsContextType | null>(null);

export const useAdsContext = () => useContext(AdsContext) as AdsContextType;
